import { createSlice } from "@reduxjs/toolkit";
import { CellTidyDataType } from "components/item/cell-tidy/index";

export const historyListHandleSlice = createSlice({
  name: "historyListHandle",
  initialState: {
    value: [],
  },
  reducers: {
    setList: (state, payload) => {
      //payload为CellTidyDataType[]
      state.value = payload.payload;
    },
    removeItem: (state, payload) => {
      //payload为CellTidyDataType[]的id<number>
      state.value = state.value.filter((item: CellTidyDataType, index) => {
        return item.postUuid !== payload.payload;
      });
    },
    clearList: (state) => {
      state.value = [];
    },
  },
});

// 为每个 case reducer 函数生成 Action creators
export const { setList, removeItem, clearList } =
  historyListHandleSlice.actions;

export default historyListHandleSlice.reducer;
